import React, { Component } from 'react';
import styles from './topBar.module.scss';

export default class TopBar extends Component {
	render() {
		return (
			<div className={styles.container}>
				<a href="https://www.yomento.com">
					<div className={styles.logo} />
				</a>

				<a className={styles.book_demo} href="https://www.yomento.com/contact-us/">
					Book a Demo
				</a>
			</div>
		);
	}
}
